import React from 'react';
import { Typography } from 'antd';
import cn from 'classnames';
import { blocks } from './constants';
import styles from './MeterInfo.module.scss';

const { Title, Text } = Typography;

const Block = ({ contentComponent = Text, title, content, contentClasses }) => {
  const ContentComponent = contentComponent;

  return (
    <div className={styles.block}>
      <Title
        level={4}
        className={styles.title}
      >
        {title}
      </Title>
      <ContentComponent className={cn(styles.content, contentClasses)}>
        {content}
      </ContentComponent>
    </div>
  );
};

const MeterInfo = ({ meter, fileUrl, fileLoading }) => {
  console.log(meter, ' meter');
  return (
    <div className={styles.root}>
      {blocks.map((block, index) => (
        <Block
          key={index}
          title={block.title}
          content={block.renderContent({
            meter,
            url: fileUrl,
            loading: fileLoading,
          })}
          contentClasses={block.contentClasses}
          contentComponent={block.contentComponent}
        />
      ))}
    </div>
  );
};

export default MeterInfo;
